var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.items && _vm.items.length)?_c('ul',{staticClass:"dapp-activities"},_vm._l((_vm.fetchedItems),function(activity,index){return _c('li',{key:activity + index,class:{ sticked: _vm.sticked },style:({
      'z-index': _vm.sticked && index > 0 ? index : 0,
      right: `${6 * index}px`,
    })},[_c('inline-svg',{attrs:{"src":_vm.getImageUrl(`activities-icons/${activity}.svg`),"alt":activity,"title":`Activity type: ` + activity}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }